module.exports = __webpack_public_path__ + "img/code-pull-request.d5f983bb.svg";